<p>footer-auth works!</p>
